/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import APIClient from "../client";
import { Button, Dropdown, Tab, Tabs } from "react-bootstrap";
import Jobs from "./Jobs";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkAgriRouter extends React.Component {
  state = {
    showModal: false,
    account: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateAgriRouterState = () => {
      this.loadAccount();
    };
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/AR/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), [
              "agrirouter",
            ]) + gettext(" Please renew your authorization.")
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              showWarning: false,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
        });
      });
  };

  authorizeAccount() {
    fetch("/apps/cloudfarm/ar_authorization_url/")
      .then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw { status: response.status };
        }
      })
      .then((json) => {
        window.open(json.ar_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  }

  async removeAccount() {
    try {
      await APIClient.remove(
        "/api/data/agrirouter/revoke/",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been deleted successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
    if (show) {
      this.loadAccount();
    }
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with agrirouter")}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              agrirouter account{" "}
              <img
                className="float-right"
                src="/static/img/agrirouter_logo.svg"
                alt="agrirouter"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="account">
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}: {this.state.account.account_id}
                    </h4>
                    {gettext("Connection expires at")}:{" "}
                    {moment(this.state.account.expiration_date).format("LL")}
                    <div className="mt-4">
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                      <a className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Renew authorization")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-4">
                      <a className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </a>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.account ? (
                  <Tractors
                    accountName={this.state.account.account_id}
                    headers={[
                      gettext("Name") + " (ar)",
                      gettext("Name") + " (Dacom)",
                      gettext("Type"),
                      gettext("Direction"),
                      gettext("Status"),
                    ]}
                    tractors={this.state.account.endpoints.map((ep) => ({
                      display: [
                        ep.endpointName,
                        cropr.machines.findWhere({ endpoint_id: ep.endpointId })?.get("name") ||
                          "-",
                        ep.endpointType,
                        ep.messageTypes[0].direction || "SEND",
                        ep.status,
                      ],
                      serialNr: ep.endpointId,
                      receiveOnly: ep.messageTypes[0].direction === "RECEIVE",
                    }))}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="AR" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to agrirouter?")}</h5>
                {gettext(
                  "With agrirouter it is possible to connect with machines from a variety of brands. Please refer to the agrirouter web site for more information on how to set up an account and connect your machine to agrirouter."
                )}{" "}
                <a href="https://www.my-agrirouter.com/" target="_blank">
                  https://www.my-agrirouter.com
                </a>
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicles and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can send the base data for your farm to each vehicle, using the buttons in the "Tractors" tab in this dialog. The base data includes field boundaries and way lines.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create plannings for your work in the "Recording" menu. If you select a connected vehicle under "Machines", the relevant field boundary and way lines will be automatically transmitted to your vehicle.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you complete a task for a planning you created beforehand, this planning will automatically be marked "performed", and enriched with data from the task. Alternatively, if no planning was made, a concept recording will be created so you can conveniently convert this into a full recording.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkAgriRouter;
